/**
 * OnboardingHeroBackground — the full-bleed stadium hero + darkening scrim used on the
 * Welcome screen (first page with the waving mascot). Extracted so the post-tutorial
 * questionnaire (OnboardingFlow) can share the exact same backdrop.
 *
 * Renders two absolutely-positioned layers; place it as the first child of a `flex: 1`
 * container whose own backgroundColor is the hero fallback, then render the real content
 * after it (later siblings paint on top).
 */

import { StyleSheet } from 'react-native';
import { Image } from 'expo-image';
import { LinearGradient } from 'expo-linear-gradient';
import { WELCOME_BACKGROUND_URI } from '../WelcomeScreen/WelcomeScreen.constants';
import {
  WELCOME_SCRIM_COLORS,
  WELCOME_SCRIM_LOCATIONS,
} from '../WelcomeScreen/WelcomeScreen.styles';
import { WEB_IMAGE_ALT_DECORATIVE } from '../../../src/shared/helpers/imageWebAlt.helper';

export function OnboardingHeroBackground() {
  return (
    <>
      <Image
        source={{ uri: WELCOME_BACKGROUND_URI }}
        style={StyleSheet.absoluteFill}
        alt={WEB_IMAGE_ALT_DECORATIVE}
        contentFit="cover"
      />
      <LinearGradient
        colors={WELCOME_SCRIM_COLORS}
        locations={WELCOME_SCRIM_LOCATIONS}
        style={StyleSheet.absoluteFill}
        pointerEvents="none"
      />
    </>
  );
}
